import { Link } from "react-router-dom";
import { FormProvider } from "react-hook-form";
import { Input } from "@/components/ui/form";
import { Button } from "@/components/ui/button";

export const LoginForm = ({ methods, mutation, onSubmit, locationState }) => {
    return (
        <FormProvider {...methods}>
            <form
                onSubmit={methods.handleSubmit(onSubmit)}
                className="grid gap-x-8 gap-y-3"
            >
                <div className="col-span-full">
                    <Input
                        name="email"
                        label="Email address"
                        placeholder="Email"
                    />
                </div>
                <div className="col-span-full">
                    <Input
                        name="password"
                        label="Password"
                        placeholder="Password"
                        type="password"
                    />
                    <div className="my-1 text-right">
                        <Link
                            to="/forgot-password"
                            state={locationState}
                            className="text-sm font-bold no-underline hover:underline"
                        >
                            Forgot your password?
                        </Link>
                    </div>
                </div>
                <div className="col-span-full">
                    <Button
                        type="submit"
                        id="submitLogin"
                        variant="primary"
                        className="w-full"
                        disabled={mutation.isPending}
                    >
                        {mutation.isPending ? "Signing In..." : "Sign In"}
                    </Button>
                </div>
            </form>
        </FormProvider>
    );
};
